var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArtTypeImage = function SvgIconArtTypeImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.499 7.333v1c0 2.986 0 4.479-.926 5.406-.928.928-2.42.928-5.406.928s-4.48 0-5.406-.928c-.928-.927-.928-2.42-.928-5.406s0-4.478.928-5.406C3.688 2 5.18 2 8.167 2l1 .001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 14c2.915-3.483 6.183-7.744 10.999-4.639m-1.666-8.027.172.464c.226.61.338.914.56 1.136.223.223.528.335 1.137.56l.465.173-.465.172c-.61.225-.914.338-1.136.56-.223.223-.335.527-.56 1.136L12.832 6l-.172-.465c-.225-.609-.338-.913-.56-1.136s-.527-.335-1.136-.56l-.465-.172.465-.172c.609-.226.914-.338 1.136-.56s.335-.527.56-1.137z"
  }))));
};
export default SvgIconArtTypeImage;